import {
  Component,
  EventEmitter,
  forwardRef,
  Inject,
  Input,
  Output
} from '@angular/core';

import { CompanyService }       from '../companies/company.service';
import { ProductSearchService } from './product.search.service';

@Component({
  selector   : 'wor-labor-product-search-control',
  template: require('./products.labor-search.control.component.html')
})
export class LaborProductsSearchControlComponent {
  @Input() label: string;
  @Input() model: string;
  @Input() name : string;

  _disabled : boolean;
  _placement: string;
  _required : boolean;

  @Input() set disabled ( _disabled : string | boolean ) {
    this._disabled = _disabled === '' || !!_disabled;
  }

  @Input() set placement (_placement: string) {
    this._placement = _placement || 'bottom-left';
  }

  @Input() set required ( _required : string | boolean ) {
    this._required = _required === '' || !!_required;
  }

  @Output() blur       : EventEmitter<Event> = new EventEmitter();
  @Output() focus      : EventEmitter<Event> = new EventEmitter();
  @Output() modelChange: EventEmitter<any>   = new EventEmitter();
  @Output() onChange   : EventEmitter<any>   = new EventEmitter();
  @Output() onSelect   : EventEmitter<any>   = new EventEmitter();

  constructor (
    @Inject(forwardRef(() => CompanyService))
    public companyService       : CompanyService,
    @Inject(forwardRef(() => ProductSearchService))
    private productSearchService: ProductSearchService
  ) {}

  formatterFn = ( product ) => {
    return typeof product === 'object'
      ? product.item_code
      : product;
  }

  searchFn = ( query : string ) => {
    return this.productSearchService.getLaborProducts(query);
  }
}